export const MY_ACCOUNT_SIDEBAR_OPEN = 'MY_ACCOUNT_SIDEBAR:OPEN';
export const MY_ACCOUNT_SIDEBAR_CLOSE = 'MY_ACCOUNT_SIDEBAR:CLOSE';
export const MY_ACCOUNT_SIDEBAR_TOGGLE = 'MY_ACCOUNT_SIDEBAR:TOGGLE';
export const MY_ACCOUNT_SIDEBAR_DATA_UPDATE = 'MY_ACCOUNT_SIDEBAR:DATA:UPDATE';
export const MY_ACCOUNT_SIDEBAR_TITLE_CHANGE = 'MY_ACCOUNT_SIDEBAR:TITLE:CHANGE';
export const MY_ACCOUNT_SIDEBAR_HOME_PAGE_SHOW = 'MY_ACCOUNT_SIDEBAR:HOME_PAGE:SHOW';
export const MY_ACCOUNT_SIDEBAR_MENU_HEIGHT_CHANGE = 'MY_ACCOUNT_SIDEBAR:HEIGHT:CHANGE';
export const MY_ACCOUNT_SIDEBAR_PORTAL_PAGE_SHOW = 'MY_ACCOUNT_SIDEBAR:PORTAL_PAGE:SHOW';
export const MY_ACCOUNT_SIDEBAR_MENU_ITEMS_MAIN_MENU_SHOW = 'MY_ACCOUNT_SIDEBAR:MAIN_MENU:SHOW';
export const MY_ACCOUNT_SIDEBAR_MENU_ITEMS_SUB_MENU_SHOW = 'MY_ACCOUNT_SIDEBAR:SUB_MENU:SHOW';

export const updateSidebarData = (data) => ({
    type: MY_ACCOUNT_SIDEBAR_DATA_UPDATE,
    payload: data
});

export const toggleSidebar = () => ({
    type: MY_ACCOUNT_SIDEBAR_TOGGLE
});

export const openSidebar = () => ({
    type: MY_ACCOUNT_SIDEBAR_OPEN
});

export const closeSidebar = () => ({
    type: MY_ACCOUNT_SIDEBAR_CLOSE
});

export const showMainMenu = () => ({
    type: MY_ACCOUNT_SIDEBAR_MENU_ITEMS_MAIN_MENU_SHOW,
    isSilent: true
});

export const changeMenuHeight = (height) => ({
    type: MY_ACCOUNT_SIDEBAR_MENU_HEIGHT_CHANGE,
    payload: height,
    isSilent: true
});

export const showSubMenu = (nextMenuItems) => ({
    type: MY_ACCOUNT_SIDEBAR_MENU_ITEMS_SUB_MENU_SHOW,
    payload: nextMenuItems,
    isSilent: true
});

export const showPortalPage = ({ pageURL, isBackArrowHidden }) => ({
    type: MY_ACCOUNT_SIDEBAR_PORTAL_PAGE_SHOW,
    payload: { pageURL, isBackArrowHidden }
});

export const changeTitle = (title) => ({
    type: MY_ACCOUNT_SIDEBAR_TITLE_CHANGE,
    payload: title,
    isSilent: true
});

export const showHomePage = () => ({
    type: MY_ACCOUNT_SIDEBAR_HOME_PAGE_SHOW,
    isSilent: true
});
